module.exports = __webpack_public_path__ + "static/media/helpInfo-icon.a81843fa.svg";